import { create } from 'zustand';
import type { WishlistItem } from '../types';

interface WishlistState {
  items:       WishlistItem[];
  asins:       Set<string>;
  setItems:    (items: WishlistItem[]) => void;
  addItem:     (item: WishlistItem) => void;
  removeItem:  (asin: string) => void;
  contains:    (asin: string) => boolean;
  clear:       () => void;
}

export const useWishlistStore = create<WishlistState>()((set, get) => ({
  items: [],
  asins: new Set(),

  setItems: (items) => set({ items, asins: new Set(items.map((i) => i.asin)) }),

  addItem: (item) =>
    set((s) => ({
      items: [...s.items, item],
      asins: new Set([...s.asins, item.asin]),
    })),

  removeItem: (asin) =>
    set((s) => {
      const asins = new Set(s.asins);
      asins.delete(asin);
      return { items: s.items.filter((i) => i.asin !== asin), asins };
    }),

  contains: (asin) => get().asins.has(asin),

  clear: () => set({ items: [], asins: new Set() }),
}));
